import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import Banners from "./components/Banners";
import Carousels from "./components/Carousels";
import Users from './components/Users';
import Images from './components/Images';
import Lotties from './components/Lotties';
import Authorize from './components/Authorize';
import Header from "./components/Header";
import Login from "./components/Login";
import Callback from "./components/Callback";
import TokenContext from './components/TokenContext';
import { createTheme, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from 'notistack';


const theme = createTheme({
  palette: {
    primary: {
      main: "#00A86C", 
    },
    secondary: {
      main: "#000000",
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontSize: "2rem",
      fontWeight: 400,
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 400,
    },

  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "8px",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
        },
      },
    },
    MuiSwitch: { 
      styleOverrides: {
        switchBase: {
          '&.Mui-checked': {
            color: '#29D884',
          },
          '&.Mui-checked + .MuiSwitch-track': {
            backgroundColor: '#29D884',
          },
        },
        thumb: {
          '&.Mui-checked': {
            backgroundColor: '#29D884',
          },
        },
      },
    },
  },
});


function AppHeader(props) {
  const { pathname } = useLocation();
  if (pathname === '/authorize') {
    return null;
  }
  return <Header {...props} />;
}

function App() {
  const [token, setToken] = useState(null);
  const [countryCode, setCountryCode] = useState('co');

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const handleSetToken = (newToken) => {
    setToken(newToken);
    if (newToken) {
      localStorage.setItem('token', newToken);
    } else {
      localStorage.removeItem('token');
    }
  };

  const handleCountryChange = (newCountryCode) => {
    setCountryCode(newCountryCode);
  };

  return (
    <SnackbarProvider maxSnack={3}>
    <TokenContext.Provider value={{ token, setToken: handleSetToken }}>
      <ThemeProvider theme={theme}>
        <Router>
        {token != null && <AppHeader onCountryChange={handleCountryChange} countryCode={countryCode}/>}
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/callback" element={<Callback />} />
            <Route path="/users" element={<Users />} />
            <Route path="/images" element={<Images countryCode={countryCode}/>} />
            <Route path="/banners" element={<Banners countryCode={countryCode}/>} />
            <Route path="/carousels" element={<Carousels countryCode={countryCode}/>} />
            <Route path="/lotties" element={<Lotties countryCode={countryCode}/>} />
            <Route path="/authorize" element={<Authorize />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </TokenContext.Provider>
    </SnackbarProvider>
  );
}

export default App;
  
